import React, { FC, ReactNode } from 'react'

import cn from 'classnames'
import ReactModal from 'react-modal'

import classes from './modal.module.scss'
import { Icon } from '../icon/icon'

export interface ModalProps extends ReactModal.Props {
  primaryCta?: ReactNode
  secondaryCta?: ReactNode
  preHeader?: ReactNode
  header?: string
  modalClassName?: string
  headerClassName?: string
  showCloseButton?: boolean
  closeButtonClassName?: string
}

export const Modal: FC<ModalProps> = ({
  children,
  primaryCta,
  secondaryCta,
  header,
  testId = 'modal-content',
  preHeader,
  modalClassName,
  headerClassName,
  showCloseButton = true,
  closeButtonClassName,
  ...props
}) => {
  return (
    <ReactModal
      testId={testId}
      className={cn(classes.modal, modalClassName)}
      overlayClassName={classes.overlay}
      {...props}
    >
      {preHeader}
      {props.onRequestClose && showCloseButton && (
        <button
          className={cn(classes.closeButton, closeButtonClassName)}
          onClick={props.onRequestClose}
          data-testid="close-modal"
          data-item-category="GI"
          data-item-name="dismiss"
          title="Close modal"
        >
          <Icon name="close" />
        </button>
      )}
      {header && (
        <h2
          className={cn(classes.header, headerClassName)}
          data-testid={`${testId}-header`}
        >
          {header}
        </h2>
      )}
      {children}
      {(primaryCta || secondaryCta) && (
        <div className={classes.actions}>
          {primaryCta}
          {secondaryCta}
        </div>
      )}
    </ReactModal>
  )
}
